import { PATIENT_LIST_PATH, PATIENT_ADD_PATH, PATIENT_EDIT_PATH, DEFAULT_DELETE_PATH } from '../../constants/paths';
import {ActionWindow} from '../../components/action_window/action_window';
import { patientAction } from './actions';
import { PatientListRoot, patientListRootLoader, PatientList, patientListLoader } from './patient_list';
import { Patient, patientAddLoader, patientEditLoader} from './patient';
import { AuthProvider } from '../../auth_provider';

const patientRoutes = [
  {
    path: PATIENT_LIST_PATH.slice(1),
    element: <PatientListRoot />,
    loader: patientListRootLoader,
    shouldRevalidate: () => false,
    children: [
      {
        path: "",
        element: <PatientList />,
        loader: patientListLoader,
        shouldRevalidate: ({ nextUrl, actionResult, formMethod }) => { 
            return AuthProvider.is_authenticated && nextUrl.pathname === PATIENT_LIST_PATH && formMethod && (!actionResult || !actionResult.message);
        },
        children: [
          {
            path: `${DEFAULT_DELETE_PATH.slice(1)}:patient_id`,
            element: <ActionWindow
                title="Deletar paciente"
                titleOnLoading="Deletando paciente"
                titleOnFail="Falha ao deletar paciente"
                description="Todos os dados relacionados ao paciente serão removidos"
                confirmText="Deletar paciente"
                onCancelPath={PATIENT_LIST_PATH}
                onFailPath={PATIENT_LIST_PATH}
                onSuccessPath={PATIENT_LIST_PATH}
                submitMethod="DELETE"
            />,
            action: patientAction
          }
        ]
      }
    ]
  },
  {
      path: PATIENT_ADD_PATH.slice(1),
      element: <Patient key="patient:add" isEdit={false} />,
      loader: patientAddLoader,
      shouldRevalidate: ({ formMethod }) => AuthProvider.is_authenticated && !formMethod,
      action: patientAction
  },
  {
      path: `${PATIENT_EDIT_PATH.slice(1)}:patient_id`,
      element: <Patient key="patient:edit" isEdit={true} />,
      loader: patientEditLoader,
      shouldRevalidate: ({ formMethod }) => AuthProvider.is_authenticated && !formMethod,
      action: patientAction
  },
];

export default patientRoutes;